import { CallIn } from '@pdcplan/shared/api/TeamPlan';
import { LoginAction, LoginEvents } from '../Login/LoginAction';
import { FindSubstituteViewAction } from './FindSubstituteViewActions';
import { Reducer } from 'redux';

export interface FindSubstituteViewReducer {
  loading: boolean;
  substitutes: Array<CallIn>;
  loadedForShift: string;
}

const initialState: FindSubstituteViewReducer = {
  loading: false,
  substitutes: [],
  loadedForShift: '',
};

const findSubstituteViewReducer: Reducer<FindSubstituteViewReducer> = (
  state: FindSubstituteViewReducer = initialState,
  action: FindSubstituteViewAction | LoginAction
) => {
  switch (action.type) {
    case LoginEvents.LOGOUT:
      return initialState;
    case 'LOADSUBSTITUTES_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'LOADSUBSTITUTES_SUCCESS':
      return {
        ...state,
        loading: false,
        substitutes: action.loadSubstitutesResponse,
      };
    case 'LOADSUBSTITUTES_FAILURE':
      return {
        ...state,
        loading: false,
      };
    case 'SET_LOADEDFORSHIFT':
      return {
        ...state,
        loadedForShift: action.id,
      };
    case 'RESET_SUBSTITUTE_STORE': {
      return { ...initialState };
    }
  }

  return state;
};

export default findSubstituteViewReducer;

